var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('div',[_c('img',{staticStyle:{"cursor":"pointer"},attrs:{"src":require("@/assets/Depreciation/cancel_action.svg"),"alt":""},on:{"click":_vm.cancelButtonClicked}})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }